import { isRequired, maxLength, minLength } from 'utils/validate/validate';
import { ENUM_STATUS_IS_SETORIAL, MSG_CAMPO_OBRIGATORIO } from 'utils/consts';

export const validationsAtendenteCreateUpdate = dadosInputs => {
  const { cpf, nome, apelido, email, cargo, isSetorial, setoresIds } = dadosInputs;
  const errosCampos = {
    cpf: null,
    nome: null,
    apelido: null,
    email: null,
    cargo: null,
    isSetorial: null,
    setoresIds: null,
  };

  errosCampos.cpf = isRequired(cpf) || minLength(cpf, 14) || maxLength(cpf, 14);
  errosCampos.nome = isRequired(nome);
  errosCampos.apelido = isRequired(apelido);
  errosCampos.email = isRequired(email);
  errosCampos.cargo = isRequired(cargo);
  errosCampos.isSetorial = isRequired(isSetorial);

  if (isSetorial === ENUM_STATUS_IS_SETORIAL.SIM.value) {
    errosCampos.setoresIds = isRequired(setoresIds);
    errosCampos.setoresIds = setoresIds?.length === 0 ? MSG_CAMPO_OBRIGATORIO : null;
  }
  return errosCampos;
};
